import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledUspModuleOuter = styled.div`
	&.background {
		background-color: ${(props) => props.backgroundColor || 'white'};
		padding: 80px 0;
		position: relative;

		&.angled {
			padding: 80px 0 20px;
			margin-bottom: 180px;

			&:before,
			&:after {
				content: '';
				position: absolute;
				bottom: -67px;
				width: 51%;
				height: 110px;
				background-color: ${(props) => props.backgroundColor || 'white'};
			}

			&:after {
				left: 0;
				transform: rotate(7deg);
			}

			&:before {
				right: 0;
				transform: rotate(-7deg);
			}
		}
	}
`;

const StyledUspModule = styled.div`
	position: relative;
	z-index: 3;

	h3 {
		font-size: ${(props) => (props.titleFontSize || '36') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '48') + 'px'};
		color: ${(props) => props.titleColor || '#212121'};

		${EmotionBreakpoint('mobile')} {
			font-size: 24px;
			line-height: 32px;
		}
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: ${(props) => props.copyColor || '#545454'};
	}
`;

const StyledUspModuleItems = styled.div`
	margin: -10px;

	${EmotionBreakpoint('notMobile')} {
		.length-6 > div {
			flex-basis: 33%;
		}
	}

	${EmotionBreakpoint('notDesktop')} {
		.length-4 > div {
			flex-basis: 50%;
		}
	}

	${EmotionBreakpoint('mobile')} {
		margin-top: 0 !important;

		.length-6 > div {
			flex-basis: 50%;
		}

		.length-3 > div {
			flex-basis: 100%;
		}

		.usphasDescription > div {
			flex-basis: 100% !important;
		}

		.subtitle.small-mobile {
			font-size: 14px;
			line-height: 20px;
		}
	}

	.subtitle {
		color: ${(props) => props.uspTitleColor || '#000000'};

		&.small {
			font-size: 14px;
			line-height: 20px;
		}
	}

	.description {
		color: ${(props) => props.uspCopyColor || '#545454'};
	}
`;
const StyledUspModuleItem = styled.div`
	${EmotionBreakpoint('mobile')} {
		&:not(.dSoM) {
			padding: 0 !important;
		}

		&.dSoM {
			padding: 5px !important;
		}

		.usphasCopy {
			flex-direction: row !important;
			align-items: center;
			margin-bottom: 16px;

			> div {
				margin-bottom: 0 !important;

				&:first-of-type {
					margin-right: 12px;
				}
			}
		}

		.description {
			text-align: left !important;
			margin-bottom: 10px;
		}
	}
`;

function UspModule({
	props: {
		title,
		titleColor,
		titleAlignment,
		titleFontSize,
		titleLineHeight,
		copy,
		copyColor,
		copyAlignment,
		items,
		uspTitleColor,
		uspCopyColor,
		uspTitleSize,
		backgroundColor,
		angledBackground,
		ctaStyle,
		ctaCopy,
		ctaLink,
		doNotStackOnMobile,
	},
}) {
	return (
		<StyledUspModuleOuter
			className={`${angledBackground ? 'angled' : ''} ${
				backgroundColor ? 'background' : ''
			}`}
			backgroundColor={backgroundColor}
		>
			<div className='container'>
				<StyledUspModule
					titleColor={titleColor}
					copyColor={copyColor}
					titleFontSize={titleFontSize}
					titleLineHeight={titleLineHeight}
				>
					{title && (
						<h3 className={'mb-20 lower text-' + titleAlignment}>{title}</h3>
					)}
					{copy && <p className={'mb-20 text-' + copyAlignment}>{copy}</p>}
					{items.length > 0 && (
						<StyledUspModuleItems
							className='mt-40'
							uspTitleColor={uspTitleColor}
							uspCopyColor={uspCopyColor}
						>
							<div
								className={
									`d-flex justify-content-center align-items-start flex-equal ${
										!doNotStackOnMobile ? 'flex-wrap' : ''
									} ${
										items[0]?.fields?.title && items[0]?.fields?.description
											? 'usphasDescription'
											: ''
									} length-` + items.length
								}
							>
								{items.map((item, index) => {
									let {
										fields: {
											title,
											description,
											file: { url },
										},
									} = item;
									return (
										<StyledUspModuleItem
											className={`text-center p-10 ${
												doNotStackOnMobile ? 'dSoM' : ''
											}`}
											key={index}
										>
											<div
												className={
													title && description
														? 'usphasCopy d-flex flex-column'
														: ''
												}
											>
												<div className='mb-20'>
													<img
														src={url}
														alt={title}
														title={title}
														className='d-inline-block mw-100'
													/>
												</div>
												{title && (
													<div
														className={
															`subtitle mb-16 ${
																uspTitleSize === 'small' ? 'lower roboto' : ''
															} ${doNotStackOnMobile ? 'small-mobile' : ''} ` +
															uspTitleSize
														}
													>
														{title}
													</div>
												)}
											</div>
											{description && (
												<div className='description'>{description}</div>
											)}
										</StyledUspModuleItem>
									);
								})}
							</div>
						</StyledUspModuleItems>
					)}
					{ctaCopy ? (
						<div className='mt-24 text-center'>
							{ctaLink ? (
								<a
									href={ctaLink}
									className={`d-inline-block btn btn-${ctaStyle}`}
								>
									{ctaCopy}
								</a>
							) : (
								<button type='button' className={`btn btn-${ctaStyle}`}>
									{ctaCopy}
								</button>
							)}
						</div>
					) : null}
				</StyledUspModule>
			</div>
		</StyledUspModuleOuter>
	);
}

export default UspModule;
